import { ILabel } from 'types/types';

export const serializeLabel = (label: ILabel) => ({
  id: label.id,
  title: label.title,
  description: label.description,
  backgroundColor: label.background_color,
  textColor: label.text_color,
});

export const serializeLabels = (labels: ILabel[]) =>
  labels.map(label => serializeLabel(label));
